import { useEffect } from 'react';
import { useAppDispatch } from '../store';

/** Own the connection at page scope, not at the responsive video component. */
export function useAvatarSessionCleanup(sessionId?: string) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const cleanup = () => {
      dispatch({ type: 'speech/reset' });
      void dispatch({ type: 'avatar/disconnect' });
    };
    // Unlike beforeunload, pagehide means the user actually chose to leave.
    window.addEventListener('pagehide', cleanup);
    return () => {
      window.removeEventListener('pagehide', cleanup);
      cleanup();
    };
  }, [dispatch, sessionId]);
}
